"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from "react";
interface IUsePaginationProps<T> {
  items?: T[];
  itemsPerPage?: number;
  initialItemsPerPage?: number;
  initialPage?: number;
  totalItems?: number;
}
const usePagination = props => {
  const $ = _c(27);
  const {
    items,
    initialItemsPerPage: t0,
    initialPage: t1,
    totalItems
  } = props;
  const initialItemsPerPage = t0 === undefined ? 10 : t0;
  const initialPage = t1 === undefined ? 1 : t1;
  const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);
  const [currentPage, setCurrentPage] = useState(initialPage);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [paginatedItems, setPaginatedItems] = useState(t2 as T[]);
  const totalPages = Math.ceil((items?.length ?? totalItems ?? 0) / itemsPerPage);
  const hasNext = currentPage < totalPages;
  const hasPrev = currentPage > 1;
  let t3;
  if ($[1] !== totalPages) {
    t3 = page => {
      const pageNumber = Math.max(1, Math.min(page, totalPages));
      setCurrentPage(pageNumber);
    };
    $[1] = totalPages;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const goToPage = t3;
  let t4;
  if ($[3] !== currentPage || $[4] !== goToPage) {
    t4 = () => {
      goToPage(currentPage + 1);
    };
    $[3] = currentPage;
    $[4] = goToPage;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const nextPage = t4;
  let t5;
  if ($[6] !== currentPage || $[7] !== goToPage) {
    t5 = () => {
      goToPage(currentPage - 1);
    };
    $[6] = currentPage;
    $[7] = goToPage;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const prevPage = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setCurrentPage(1);
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const reset = t6;
  let t7;
  let t8;
  if ($[10] !== currentPage || $[11] !== items || $[12] !== itemsPerPage) {
    t7 = () => {
      if (!items || items.length === 0) {
        setPaginatedItems([]);
        return;
      }
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      setPaginatedItems(items.slice(startIndex, endIndex));
    };
    t8 = [items, currentPage, itemsPerPage];
    $[10] = currentPage;
    $[11] = items;
    $[12] = itemsPerPage;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[15] !== initialPage) {
    t9 = () => {
      setCurrentPage(initialPage);
    };
    t10 = [initialPage];
    $[15] = initialPage;
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  useEffect(t9, t10);
  let t11;
  if ($[18] !== currentPage || $[19] !== goToPage || $[20] !== hasNext || $[21] !== hasPrev || $[22] !== nextPage || $[23] !== paginatedItems || $[24] !== prevPage || $[25] !== totalPages) {
    t11 = {
      setItemsPerPage,
      currentPage,
      totalPages,
      paginatedItems,
      goToPage,
      nextPage,
      prevPage,
      reset,
      hasNext,
      hasPrev
    };
    $[18] = currentPage;
    $[19] = goToPage;
    $[20] = hasNext;
    $[21] = hasPrev;
    $[22] = nextPage;
    $[23] = paginatedItems;
    $[24] = prevPage;
    $[25] = totalPages;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};
export default usePagination;